import * as Yup from 'yup';

export const YupValidationError = Yup.ValidationError;

export const YupShape = (val: Yup.ObjectSchemaDefinition<object>) => Yup.object().shape(val);

export const YupString = () => Yup.string();

export const YupStringRequired = (message: string | undefined = undefined) => {
  return YupString().required(message && message);
};

export const YupEmail = (messageEmail: string, messageRequired: string | undefined = undefined) => {
  const mailValidation = Yup.string().email(messageEmail)
  if(messageRequired) {
    return mailValidation.required(messageRequired);
  }
  return mailValidation;
}

export const YupCpfCnpj = (apenasCpf: boolean = false) => {
  return Yup.string().min(11,'Mínimo 11 números').max(apenasCpf ? 11 : 14,`Máximo ${apenasCpf ? 11 : 14} números`).test('number-only', 'Apenas números', val => {
    if(!val) return true;            
    return val.replace(/\d/g,'').length === 0
  });
}

export const YupTelefone = () => {
  return Yup.string().min(10,'Mínimo 10 números').max(11,'Máximo 11 números').test('number-only', 'Apenas números', val => {
    if(!val) return true;
    return val.replace(/\d/g,'').length === 0
  });
}

export const YupUF = () => {
  return Yup.string().min(2,'Use duas letras. Ex.: SP').max(2,'Use duas letras. Ex.: SP');
}

export const YupCep = () => {
  return Yup.string().required('Campo obrigatório').min(8,'CEP inválido').max(8,'CEP inválido');
}

export const YupConexoes = () => {
  return Yup.number().required('Campo obrigatório').integer('Apenas números inteiros').positive('Apenas números maiores que 0')
    .moreThan(0,'Apenas números maiores que 0').typeError('Apenas números')
}